import { render } from "./AddEditGimSubBrand.vue?vue&type=template&id=6edef43a"
import script from "./AddEditGimSubBrand.vue?vue&type=script&lang=js"
export * from "./AddEditGimSubBrand.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__